import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-321ec311"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text" }
const _hoisted_2 = {
  key: 1,
  class: "count"
}
const _hoisted_3 = {
  key: 0,
  class: "empty"
}

interface Props {
  /** title of info block */
  title: string;
  /** icon next to title */
  icon?: string;
  /** number next to title */
  count?: number;
  /**
   * whether or not to show "no info" placeholder. why? to show that this field
   * exists, but doesn't have data this time.
   */
  blank?: boolean;
  /** whether info block is full width or not */
  big?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppDetail',
  props: {
    title: null,
    icon: { default: "" },
    count: { default: undefined },
    blank: { type: Boolean, default: false },
    big: { type: Boolean, default: false }
  },
  setup(__props: any) {

/**
 * for fields not relevant to current page (e.g. taxon on a disease node page),
 * hide with v-if. for relevant fields, show with v-if, to indicate that field
 * exists, but pass "blank" prop to indicate that no data available
 */



return (_ctx: any,_cache: any) => {
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_AppFlex = _resolveComponent("AppFlex")!

  return (_openBlock(), _createBlock(_component_AppFlex, {
    ref: "cell",
    "h-align": "left",
    direction: "col",
    gap: "small",
    class: "detail",
    "data-big": __props.big
  }, {
    default: _withCtx(() => [
      _createVNode(_component_AppFlex, {
        gap: "small",
        "h-align": "left"
      }, {
        default: _withCtx(() => [
          (__props.icon)
            ? (_openBlock(), _createBlock(_component_AppIcon, {
                key: 0,
                icon: __props.icon,
                class: "icon"
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_1, _toDisplayString(__props.title), 1),
          (__props.count !== undefined)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.count), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (__props.blank)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "No info"))
        : _renderSlot(_ctx.$slots, "default", { key: 1 })
    ]),
    _: 3
  }, 8, ["data-big"]))
}
}

})